import React, { useState, useEffect} from 'react'
import api from '../../../../../core/services/api'
import MaterialTable, { MTableToolbar } from "material-table";


//material-ui
import FormGroup from '@material-ui/core/FormGroup'
import {Grid, IconButton} from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import { makeStyles } from "@material-ui/core/styles";
import {SpeedDial, SpeedDialIcon, SpeedDialAction} from "@material-ui/lab";


//custom components
import Main from '../../../components/Main'
import CreateForm from './CreateForm'
import EditForm from './EditForm'






const useStyles = makeStyles({
  root: {
    transform: "translateZ(0px)",
    flexGrow: 1,
    color: '#69f0ae'
  },
  speedDial: {
    zIndex: 9999,
    position: "fixed",
    bottom: "12%",
    right: "0.2%",
    "& .MuiSpeedDial-fab": {
      backgroundColor: '#5ad545'
    },
  }
}
);


function Segments(){
  const classes = useStyles();
  const [state, setState] = useState({
    segments: [],
  })
  const [open, setOpen] = useState(false);
  const [direction, setDirection] = React.useState("up"); 
  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  useEffect(() => {
    getData();
  }, [])

  async function getData() {
    try {
      const {data} = await api.get(`segments`);
      setState((prev) => ({
        ...prev,
        segments: data.data.data || []
      }))
    } catch (error) {
      console.warn(error)
    }
  };

  async function deleteSegment(segment) {
    try {

      if (
        window.confirm(
          "Tem certeza que deseja deletar o segmento " + segment.name
        )
      ) {
       
        await api.delete(`segments/${segment.id}`);
      }

      getData();
    } catch (error) {
      console.warn(error)
    }
  };
    return (
        <>
           <Grid container justify="flex-end" spacing={3} style={{ paddingBottom: 12 }}>
        <Grid item>
        <SpeedDial
            ariaLabel="SpeedDial example"
            className={classes.speedDial}
            icon={<SpeedDialIcon />}
            onClose={handleClose}
            onOpen={handleOpen}
            open={open}
            direction={direction}
            getData={getData}
            optionType={state.optionType}
          >
            <SpeedDialAction
              key="CreateForm "
              icon={<CreateForm getData={getData} />}
              tooltipTitle="Novo Segmento"
              onClick={() => handleOpen()}
            />
          </SpeedDial>   
                </Grid>
      </Grid>
     
        <MaterialTable
        columns={[
          {
            title: "Nome",
            field: "name",
            cellStyle: { paddingLeft: 24, textAlign: "left", paddingRight: 80 },
            headerStyle: { borderBottom: '#fff', borderRadius: '8px 0px 0px 0px' }
          },
          {
            field: "actions",
            title: "Ações",
            cellStyle: { paddingBottom: 0, paddingTop: 0, textAlign: "right" },
            headerStyle: { paddingRight: 20, textAlign: "right", borderRadius: '0px 8px 0px 0px' },
            render: (rowData) => (
              <>
              <FormGroup row style={{ justifyContent: 'flex-end' }}>
                <EditForm segments={rowData} getData={getData} />
                <IconButton
                  style={{ color: "#ec273b" }}
                  onClick={() => deleteSegment(rowData)}
                >
                  <DeleteIcon />
                </IconButton>{" "}
              </FormGroup>
            </>
            ),
          },
        ]}
        data={state.segments}
        options={{
          pageSize: 10,
          actionsColumnIndex: -1,
          search: false,
          showTitle: false,
          tableLayout: 'auto',
          headerStyle: {
            paddingLeft: 24,
            //textAlign: "left",
            backgroundColor: "#fff",
            color: "#777",
            border: '0px solid #777',
          },
          rowStyle: (x) => {
            if (x.tableData.id === 0) {
              return { borderTop: '2px solid rgb(212, 212, 212)' }
            }
          },
        }}
        components={{
          Toolbar: (props) => (
            <div style={{ display: "none" }}>
              <MTableToolbar {...props} />
            </div>
          ),
        }}
        style={{
          borderRadius: 10,
        }}
      />
   </>
    )
}



export default Segments;